import { PlusCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AuthCTAProps {}

export default function AuthCTA({}: AuthCTAProps) {
  const navigate = useNavigate();
  return (
    <div className="bg-gradient-to-r from-primary-50 to-accent/20 rounded-2xl p-8 mb-12">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-dark-900 mb-4">
          Have something to sell?
        </h2>
        <p className="text-lg text-dark-600 mb-8">
          Post your ad and reach buyers in your area. It's quick and easy.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/post-ad')}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-xl font-semibold hover:bg-primary-700 transition-colors"
          >
            <PlusCircle className="w-5 h-5" />
            Post Your Ad
          </button>
        </div>
      </div>
    </div>
  );
}
